// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const Layer1Md = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_11980_185)">
            <path d="M1.6665 10.0001L9.70167 14.0177C9.811 14.0723 9.86567 14.0997 9.923 14.1104C9.97375 14.1199 10.0259 14.1199 10.0767 14.1104C10.134 14.0997 10.1887 14.0723 10.298 14.0177L18.3332 10.0001M1.6665 14.1668L9.70167 18.1843C9.811 18.239 9.86567 18.2663 9.923 18.2771C9.97375 18.2866 10.0259 18.2866 10.0767 18.2771C10.134 18.2663 10.1887 18.239 10.298 18.1843L18.3332 14.1668M1.6665 5.8334L9.70167 1.8158C9.811 1.76115 9.86567 1.73381 9.923 1.72306C9.97375 1.71353 10.0259 1.71353 10.0767 1.72306C10.134 1.73381 10.1887 1.76115 10.298 1.8158L18.3332 5.8334L10.298 9.85101C10.1887 9.90568 10.134 9.93301 10.0767 9.94376C10.0259 9.95326 9.97375 9.95326 9.923 9.94376C9.86567 9.93301 9.811 9.90568 9.70167 9.85101L1.6665 5.8334Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_11980_185">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
